module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "divider brtd"
  }), _vm._v(" "), _c('p', {
    staticClass: "document",
    class: _vm.openedClass
  }, [_c('a', {
    attrs: {
      "href": _vm.fileLink,
      "target": "_blank"
    },
    domProps: {
      "textContent": _vm._s(_vm.name)
    },
    on: {
      "click": function($event) {
        _vm.markOpened()
      }
    }
  }), _c('br'), _vm._v(_vm._s(_vm.description)), _c('br'), _vm._v(" "), _c('small', [(!_vm.hasBeenRead) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.markRead()
      }
    }
  }, [_vm._v("Mark as read")]) : _c('span', [_vm._v("Document has been marked as read")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-119fada4!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/Resource/Document.vue
// module id = 409
// module chunks = 0